<template>
  <div class="layout">
    <div class="head">
      <slot name="head"></slot>
    </div>
    <div class="main">
      <slot name="main"></slot>
    </div>
    <div class="sidebar">
      <slot name="secondary"></slot>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.layout {
  display: grid;
  grid-template-rows: auto;
  grid-template: 'head head' 'sidebar main' / 2fr 3fr;
  color: var(--resume-font-color);
  font-family: var(--resume-font-family);
  padding: var(--resume-margin);
  line-height: var(--resume-line-height);
  :deep(h1),
  :deep(h2),
  :deep(h3) {
    @apply font-bold;
    color: var(--resume-primary-color);
    font-family: var(--resume-font-family);
  }

  .sidebar,
  .main,
  .head {
    grid-area: sidebar;
    @apply bg-transparent;
  }

  .sidebar,
  .main {
    grid-area: main;
    @apply pt-2-em;
  }
  .head {
    grid-area: head;
    background-color: var(--resume-background-color-dark);
    page-break-after: avoid;
  }
  .sidebar {
    @apply pl-8-em;
    grid-area: sidebar;
    background-color: var(--resume-background-color);
    background: linear-gradient(
      180deg,
      var(--resume-background-color) 0%,
      var(--resume-background-color) 50%,
      rgba(255, 255, 255, 0) 100%
    );
  }
  .main {
    @apply pr-8-em;
  }
}
</style>
